// src/pages/Ozone.js
import React from 'react';
import MiniToolPageLayout from '../components/MiniToolPageLayout';
import OzoneTool from '../components/OzoneTool';
import { IoSearchCircleOutline } from 'react-icons/io5';

// --- Page-Specific Data ---
const pageData = {
  seo: {
    title: "Ozone Lead Finder | Free Website Scanner | Oolook",
    description: "Instantly find email addresses, phone numbers, and social media links from any website with Ozone, Oolook's free lead-finding tool.",
    image: 'https://oolook.in/og/ozone.png',
    schemas: [{
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "Ozone Lead Finder",
      "operatingSystem": "All",
      "applicationCategory": "BusinessApplication",
      "description": "A free online tool to scan any website and extract public contact information like emails, phone numbers, and social media profiles.",
      "url": "https://oolook.in/ozone",
      "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" },
    }]
  },
  hero: {
    icon: IoSearchCircleOutline,
    title: "Ozone Lead Finder",
    subtitle: "Turn any website into a lead list. Enter a domain and instantly extract publicly available emails, phone numbers, and social media profiles."
  },
  guide: {
    title: "How It Works",
    subtitle: "Effortless lead discovery in three simple steps.",
    steps: [
      { title: "1. Enter a Website URL", description: "Paste any website domain (e.g., oolook.in) into the search bar. Our tool works with or without 'https://'." },
      { title: "2. Let Ozone Scan", description: "Our smart crawler visits the website and intelligently searches for contact information and social media links across its pages." },
      { title: "3. Get Your Lead List", description: "Within seconds, Ozone presents a clean, organized list of all the contact details it discovered, ready for you to use." }
    ]
  }
};

const Ozone = () => {
  return (
    <MiniToolPageLayout seo={pageData.seo} hero={pageData.hero} guide={pageData.guide}>
      <OzoneTool />
    </MiniToolPageLayout>
  );
};

export default Ozone;